import React from "react"
import { Button, Navbar } from "react-bootstrap"

export const AddLineFriendsLink = () => {
  return (
    <>
      <Navbar.Text>
        <Button
          className="me-lg-3"
          variant="light"
          target="blank"
          rel="noopener noreferrer"
          href="https://lin.ee/C7WxFsW"
        >
          お問い合わせLINE登録
        </Button>
      </Navbar.Text>
    </>
  )
}
